// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ranking_wrapper__2m96g","optionsList":"Ranking_optionsList__3eTio","option":"Ranking_option__35_Sh","leftSide":"Ranking_leftSide__2VA6D"};